// src/services/admin/admin.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const adminApi = createApi({
  reducerPath: "admin",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BACKEND_URL}/api/admin/`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["Admin"],
  endpoints: (builder) => ({
    getAdminStatus: builder.query({
      query: () => "admin-status",
      providesTags: ["Admin"],
      refetchOnFocus: true,
      refetchOnReconnect: true,
    }),
  }),
});

export const { useGetAdminStatusQuery } = adminApi;
export default adminApi;
export { adminApi };
